
<style>
    .mapChart{
        width: 100%;
        height: 450px;
        display: inline-block;
        background-color: #1e094e;
        box-shadow: 0 2px 12px 0 rgba(30,9,78, 1);
    }
</style>

<template>
    <div class="mapChart Chart" id="mapChart" @dblclick="returnDbClickFn"></div>
</template>
<script>

    // import axios from 'axios';

    import geoJsonChina from '../../assets/geoJsonChina.json';
    import geoJsonWorldJson from '../../assets/geoJsonWorld.json';

    export default {
        name: 'mapChart',
        props: ['mapMess','widthPxMess','dataBol'],
        data(){
            return {
                mapIndex:false,
                geoJsonWorldJson,
                geoJsonChina,
				dealWithData:[
				              {name: '北京市', value: 45, selected:1},
				              {name: '天津市', value: 45, selected:1},
				              {name: '上海市', value: 45},
				              {name: '重庆市', value: 45},
				              {name: '河北省', value: 45},
				              {name: '河南省', value: 45},
				              {name: '云南省', value: 45},
				              {name: '辽宁省', value: 45},
				              {name: '黑龙江省', value: 45},
				              {name: '湖南省', value: 45},
				              {name: '安徽省', value: 45},
				              {name: '山东省', value: 45},
				              {name: '新疆维吾尔自治区', value: 45},
				              {name: '江苏省', value: 45},
				              {name: '浙江省', value: 45},
				              {name: '江西省', value: 45},
				              {name: '湖北省', value: 45},
				              {name: '广西省', value: 45},
				              {name: '甘肃省', value: 45},
				              {name: '山西省', value: 45},
				              {name: '内蒙古自治区', value: 45},
				              {name: '陕西省', value: 45},
				              {name: '吉林省', value: 45},
				              {name: '福建省', value: 45},
				              {name: '贵州省', value: 45},
				              {name: '广东省', value: 45},
				              {name: '青海省', value: 45},
				              {name: '西藏自治区', value: 45},
				              {name: '四川省', value: 45},
				              {name: '宁夏省', value: 45},
				              {name: '海南省', value: 45},
				              {name: '台湾省', value: 45},
				              {name: '香港', value: 45},
				              {name: '澳门', value: 45},
				]
            }
        },
        watch:{
			mapMess:{
				handler(ev){
					this.getWorld();
				},deep:true
			}
        },
        mounted(){
            let myChart = this.$echarts.init(document.getElementById('mapChart'));
            this.myChart = myChart;
			this.getWorld();
            this.chinaClickFn();  
        },
        methods:{
            getWorld(){
                let _this = this;
                _this.$echarts.registerMap('myMap', _this.geoJsonWorldJson);
                _this.drawChart(_this.mapMess.valueArr);
            },
            chinaClickFn(){
                let _this = this;
                _this.myChart.on('click', function(params) {
                    if(Object.is(params.name,'中国')){
                        _this.$echarts.registerMap('myMap', _this.geoJsonChina);
                        // _this.drawChart(_this.dealWithData,'中國地圖')
						_this.drawChart(_this.mapMess.chinalist,'中國地圖')
                        _this.mapIndex = true;
                    }
                });
            },
            returnDbClickFn(){
                let _this = this;
                if(_this.mapIndex){
                    _this.$echarts.registerMap('myMap', _this.geoJsonWorldJson);
                    _this.drawChart(_this.mapMess.valueArr);
                    _this.mapIndex = false;
                }
            },
            drawChart(arrlist,name='世界地圖'){
                let _this = this;
				console.log(arrlist)
                _this.myChart.setOption({
                    title:{
                        text:name,
                        textStyle:{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontSize:_this.widthPxMess.titleSize
                        },
                        x:'center',
                        y:'20',
                    },
                    width:'auto',
                    tooltip: {
                        trigger: 'item', // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用
                        // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
                        // 使用函数模板  传入的数据值 -> value: number | Array
                        formatter: function (res) {
                            // console.log(res);
                            // return res.name
                            if(res.data){
                                return res.data.name + ': ' + res.data.val
                            }else{
								return res.name + ': ' + 0
							}
                        }
                    },
                    series: [{
                        // 圖標類型
                        type: 'map',
                        // 地圖數據
                        map: 'myMap',
                        // 是否開啟鼠標縮放和平移漫遊
                        roam: true,
                        // 放大縮小極值設置
                        scaleLimit :{
                            min : 1,
                            max : 6
                        },
                        left:'center',
                        top:'18%',

                        // zoom:'1.5',
                        // layoutCenter: ['50%', '55%'],
                        // layoutSize: '100%',

                        // 图形上的文本标签
                        label: {
                            show: false, // 是否显示对应地名
                            position:'top'
                        },
                        // 地圖css設置
                        itemStyle: {
                            areaColor: '#2c51d0', // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
                            borderWidth: 0.3, // 描边线宽 为 0 时无描边
                            borderColor: '#2c51d0', // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
                            borderType: 'solid' // 描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'
                        },
                        // 高亮設置
                        emphasis: {
                            label: {
                                show: false, // 是否显示标签
                                color: '#fff' // 文字的颜色 如果设置为 'auto'，则为视觉映射得到的颜色，如系列色
                            },
                            itemStyle: {
                                areaColor: '#ffd814' // 地图区域的颜色
                            }
                        },
                        // 自定义地区的名称映射
                        nameMap: _this.mapMess.nameArr,
                        // 地图系列中的数据内容数组 数组项可以为单个数值
                        data: arrlist
                    }]
                },true);
            },
        }
    }
</script>